<template>
	<div class="comListLoad_container">
		<van-list
			v-if="total > 0"
			v-model="loading"
			:finished="finished"
			:loading-text="$t('加载中')"
			:finished-text="$t('没有更多了')"
			@load="onLoad"
		>
			<slot name="list"></slot>
		</van-list>
		<div v-else>
			<van-empty :description="$t('暂无数据')"></van-empty>
		</div>
	</div>
</template>

<script>
export default {
	name: "ComListLoad",
	props: {
		total: {
			type: Number,
			default: 0,
		},
		dataLength: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			loading: false,
			finished: false,
		};
	},
	methods: {
		onLoad() {
			setTimeout(() => {
				// 如果已经全部加载完成，就直接结束
				if (this.dataLength >= this.total) {
					this.finished = true;
					this.loading = false;
					return;
				}
				// 触发父组件加载
				this.$emit("loadMore");
			}, 500);
		},
	},
	watch: {
		// 当总数变化时，重置 finished
		total() {
			this.finished = false;
		},
		// 当已加载数据变化时，判断是否加载完成
		dataLength(newVal) {
			if (newVal >= this.total) {
				this.finished = true;
			}
			this.loading = false; // 每次加载完成后手动关闭 loading
		},
	},
};
</script>
